import React from 'react';
import { Grid, Card } from '@mui/material';
import { format } from 'date-fns';
import { Title } from '../../../../components/atoms/title';
import { useUniversities } from '../../../../hooks/universities';

export function IssueDescription({ issueData }) {
  const issueType = issueData?.type;
  const title =
    issueType === 'info change'
      ? 'Alteração de informações'
      : issueType === 'payment'
      ? 'Problema de pagamento'
      : 'Bug';

  function formatInfoKey(key) {
    const translations = {
      first_name: 'Nome',
      gender: 'Gênero',
      birthday: 'Data de nascimento',
      major_id: 'Curso',
      university_id: 'Universidade',
    };

    return translations[key] || key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
  }

  const { majors, universities } = useUniversities();

  const getMajorName = majorId => {
    return majors.find(major => major.id === majorId)?.name;
  };

  const getUniversityName = universityId => {
    return universities.find(university => university.id === universityId)?.name;
  };

  function formatValue(key, value) {
    if (key === 'major_id') {
      return getMajorName(value);
    }
    if (key === 'birthday') {
      return new Date(value).toLocaleDateString('en-GB');
    }
    if (key === 'university_id') {
      return getUniversityName(value);
    }
    if (key === 'gender') {
      if (value === 'male') {
        return 'Masculino';
      }
      if (value === 'female') {
        return 'Feminino';
      }
      if (value === 'non-binary') {
        return 'Não binário';
      }
    }
    return value;
  }

  const formattedDate = format(new Date(issueData?.updated_at), 'dd/MM/yyyy HH:mm');

  return (
    <>
      <Title>{title}</Title>

      {issueType === 'info change' && (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card style={{ padding: '10px', marginBottom: '32px', border: '1px solid #ccc', boxShadow: 'none' }}>
              <Grid
                style={{ padding: '8px 16px 8px 16px' }}
                container
                direction='column'
                alignItems='flex-start'
                spacing={1}
              >
                {Object.entries(issueData?.info).map(([key, value]) => (
                  <p key={key}>
                    <strong>{formatInfoKey(key)}: </strong>
                    {formatValue(key, value)}
                  </p>
                ))}
                {issueData?.document_url && (
                  <a href={issueData.document_url} target='_blank' rel='noreferrer'>
                    <img
                      src={issueData.document_url}
                      alt='Document'
                      style={{
                        maxHeight: '300px',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        marginTop: '8px',
                      }}
                    />
                  </a>
                )}
                <p style={{ marginTop: '8px' }}>{formattedDate}</p>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      )}
      {(issueType === 'bug' || issueType === 'payment') && (
        <Grid container>
          <Grid item xs={12}>
            <Card style={{ padding: '10px', marginBottom: '32px', border: '1px solid #ccc', boxShadow: 'none' }}>
              <Grid
                style={{ padding: '8px 16px 8px 16px' }}
                container
                direction='column'
                alignItems='flex-start'
                spacing={1}
              >
                <p style={{ marginTop: '0' }}>
                  {' '}
                  <strong>Descrição: </strong>
                  {issueData?.content}
                </p>
                <p style={{ marginTop: '8px' }}>{formattedDate}</p>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      )}
    </>
  );
}
